import { Item } from "@/services/backend/htz/inspection/types/visual-assessment-catalog";
import { UUID } from "@/shared/types/entity-id";
import { Result } from "@/services/backend/htz/inspection/components/inspection-result";
import { Assessment } from "./assessment";

export type VisualAssessment = Assessment & {
  deficiency: string;
  recommendation: string;
  comment: string;
  conductedAt: string;
  result: Result;
};

export function newVisual(
  id: UUID,
  ahuId: UUID,
  componentId: UUID,
): VisualAssessment {
  return {
    id,
    ahuId,
    componentId,
    deficiency: "",
    recommendation: "",
    comment: "",
    conductedAt: new Date().toISOString(),
    result: Result.ZERO,
  };
}

export function fromCatalogItem(
  id: string,
  ahuId: UUID,
  componentId: string,
  item: Item,
): VisualAssessment {
  return {
    ...item,
    id,
    ahuId,
    componentId,
    comment: "",
    conductedAt: new Date().toISOString(),
  };
}
